const debug = require("debug");

const { formatLogContext } = require("./formatLogContext");

let isPatched = false;

/**
 * Adds the request context to every 'debug' line without touching any call
 * site. 'debug' resolves createDebug.formatArgs at call time, so replacing it
 * once covers every namespace in the process.
 *
 * The prefix is inserted before delegating: the original implementation
 * prepends the namespace and appends the '+Nms' diff, so prepending first
 * lands the context between the namespace and the message.
 */
function patchDebugWithContext() {
  if (isPatched) {
    return;
  }

  isPatched = true;

  const originalFormatArgs = debug.formatArgs;

  debug.formatArgs = function formatArgsWithContext(args) {
    const prefix = formatLogContext();

    if (prefix && typeof args[0] === "string") {
      args[0] = `${prefix} ${args[0]}`;
    }

    originalFormatArgs.call(this, args);
  };
}

module.exports = { patchDebugWithContext };
